import React, { Component } from 'react'

class CheckEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: localStorage.getItem('emailForSignIn'),
    }
  }

  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Tree Tracker App</a>
          </div>
        </nav>

        <div className="col-md-5 margin-top-container">
          <h3>Check {this.state.email} for your sign-in link!</h3>
        </div>

        <footer className="py-5 bg-black bottom-footer ">
          <div className="container">
            <p className="m-0 text-center text-white small">Copyright &copy; Tree Tracker App {new Date().getFullYear()}</p>
          </div>
        </footer>

      </div>
    )
  }
}
export default CheckEmail




// WEBPACK FOOTER //
// ./src/components/check-email/CheckEmail.js